import React, { useEffect , useRef, useState} from 'react';
import ScrollToTop from '../../Shared/ScrollToTop';
import Footer from '../../layout/Footer/Footer';
import Header from '../../layout/Header/Header';
import { Link } from 'react-router-dom';
import emailjs from "@emailjs/browser";

import Aos from "aos";


import './Contact.css'

import bg from '../../../images/banner/psx1.jpg'
import { useTranslation } from "react-i18next";

const Contact = ({ lang, SetLang }) => {
    const [t, i18n] = useTranslation('traduction');
    const form= useRef();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => {
        Aos.init({
            duration: 1500,
            disable: 'mobile',
            once: true,
            mirror: false
        });
        i18n.changeLanguage(lang);
    }, [i18n, lang]);

    const subimtHandler = (e) => {
        e.preventDefault();
        setName("");
        setEmail("");
        setMessage("");
        emailjs
          .sendForm(
            "service_776bohd",
            "template_gskljxo",
            form.current,
            "FGxlpcbtiIbVO1ZOj"
          )
          .then(
            (result) => {
              console.log("Email sent");
              // console.log(result.text);
            },
            (error) => {
              console.log(error.text);
            }
          );
      };

    return (
        <>
            <Header lang={lang} SetLang={SetLang} />
            <div class="page-content bg-white">
                <div class="dlab-bnr-inr overlay-black-middle bg-pt" style={{ backgroundImage: "url(" + bg + ")" }}>
                    <div class="container">
                        <div class="dlab-bnr-inr-entry">
                            <h1 class="text-white">{t('Contactez-Nous')}</h1>
                            <div class="breadcrumb-row">
                                <ul class="list-inline">
                                    <li><Link to="/index">{t('Accueil')}</Link></li>
                                    <li>{t('Contactez-Nous')}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-full content-inner bg-white contact-style-1">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 d-flex m-b30" data-aos="fade-down-right">
                                <div class="p-a30 border contact-area border-1 align-self-stretch radius-sm">
                                    <h3 class="m-b5">{t('Contact Rapide')}</h3>
                                    <p>{t('Si vous avez des questions, utilisez simplement les coordonnées suivantes.')}</p>
                                    <ul class="no-margin">
                                        <li class="icon-bx-wraper left m-b30">
                                            <div class="icon-bx-xs border-1"> <Link to="/#" class="icon-cell"><i class="ti-location-pin"></i></Link> </div>
                                            <div class="icon-content">
                                                <h6 class="text-uppercase m-tb0 dlab-tilte">{t('Addresse:')}</h6>
                                                <p>{t('Route de Tunis km24, Z.I. Ghraba 3043, Sfax - Tunisie')}</p>
                                            </div>
                                        </li>
                                        <li class="icon-bx-wraper left  m-b30">
                                            <div class="icon-bx-xs border-1"> <Link to="/#" class="icon-cell"><i class="ti-email"></i></Link> </div>
                                            <div class="icon-content">
                                                <h6 class="text-uppercase m-tb0 dlab-tilte">{t('Email:')}</h6>
                                                <p>direction.generale@devpack.com.tn</p>
                                            </div>
                                        </li>
                                        <li class="icon-bx-wraper left">
                                            <div class="icon-bx-xs border-1"> <Link to="/#" class="icon-cell"><i class="ti-mobile"></i></Link> </div>
                                            <div class="icon-content">
                                                <h6 class="text-uppercase m-tb0 dlab-tilte">{t('Téléphone')}</h6>
                                                <p>+216 71 136 670</p>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="m-t20">
                                        <ul class="dlab-social-icon border dlab-social-icon-lg">
                                            <li><Link to="/#" class="fa fa-linkedin bg-primary"></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6  mb-4 m-b30 mb-md-0" data-aos="fade-down">
                                <div class="p-a30 bg-gray clearfix radius-sm">
                                    <h3 class="m-b10">{t('Envoyez-nous votre message')}</h3>
                                    <div class="dzFormMsg"></div>
                                    <form ref={form} method="post" class="dzForm" onSubmit={subimtHandler}>
                                        <input type="hidden" value="Contact" name="dzToDo" />
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="form-group">
                                                    <div class="input-group">
                                                        <input               value={name} onChange={(e) => setName(e.target.value)} name="dzName" type="text" required class="form-control" placeholder={t('Votre Nom')} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="form-group">
                                                    <div class="input-group">
                                                        <input  onChange={(e) => setEmail(e.target.value)} value={email} name="dzEmail" type="email" class="form-control" required placeholder={t('Votre Adresse Email')} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="form-group">
                                                    <div class="input-group">
                                                        <textarea onChange={(e) => setMessage(e.target.value)} value={message} name="dzMessage" rows="4" class="form-control" required placeholder={t('Votre Message...')}></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-12">
                                                <button name="submit" type="submit"class="site-button "> <span>{t('Envoyer')}</span> </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div class="col-lg-4 d-flex m-b30" >
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3270.8216209415423!2d10.745449614444164!3d34.936010378088355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1301dba3dd316e93%3A0xc0e15b1bc04ca40f!2sDEVPACK!5e0!3m2!1sfr!2stn!4v1624440652546!5m2!1sfr!2stn" class="align-self-stretch radius-sm" style={{ border: "0", width: "100%", minHeight: "100%" }} allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer lang={lang} SetLang={SetLang} />
            <ScrollToTop className="scroltop style2 radius " />
        </>

    );
}

export default Contact;